import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App.jsx';
import './shared/styles/analytics.css';
import './shared/styles/platform.css';

document.body.classList.add('analytics-body');

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
